<template>
  <div>
    <v-window v-model="manageTabIndex" :mandatory="false" :touch="false">
      <!-- TAB ACCOUNT USERS -->
      <v-window-item :transition="false" :reverse-transition="false" value="company-users" eager>
        <manage-users-list @remove-user="openRemoveUserModal" @on-update-user-rights="onUpdateUserRights"></manage-users-list>
      </v-window-item>

      <!-- TAB ORGANIZATION -->
      <v-window-item v-if="hasOrganization" :transition="false" :reverse-transition="false" value="company-organization" eager>
        <manage-users-organization @remove-user="openRemoveUserModal" @on-update-user-rights="onUpdateUserRights"></manage-users-organization>
      </v-window-item>

      <!-- TAB GROUPS -->
      <v-window-item :transition="false" :reverse-transition="false" value="company-groups" eager>
        <premium-section feature="groups">
          <manage-users-groups></manage-users-groups>
        </premium-section>
      </v-window-item>

      <!-- TAB OPEN USERS -->
      <v-window-item v-for="user in openedUsers" :key="user.id" :transition="false" :reverse-transition="false" :value="`company-user${user.id}`">
        <manage-users-user-acr ref="userTabs" :user="user"></manage-users-user-acr>
      </v-window-item>
    </v-window>

    <!-- MODALS -->
    <manage-users-user-remove v-if="userToRemove" :user-to-remove="userToRemove" @close="userToRemove = null"></manage-users-user-remove>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import useEventbusStore from '@/stores/eventbus';
  import useManageStore from '@/stores/manage';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import ManageUsersList from './ManageUsersList';
  import ManageUsersOrganization from './ManageUsersOrganization';
  import ManageUsersGroups from './ManageUsersGroups';
  import ManageUsersUserAcr from './ManageUsersUserAcr';
  import ManageUsersUserRemove from './ManageUsersUserRemove';

  export default {
    components: {
      ManageUsersList,
      ManageUsersOrganization,
      ManageUsersGroups,
      ManageUsersUserAcr,
      ManageUsersUserRemove,
    },
    data() {
      return {
        userToRemove: null,
        usersAccessRightStore: useUsersAccessRightStore(),
        manageStore: useManageStore(),
        eventbusStore: useEventbusStore(),
      };
    },
    computed: {
      manageTabIndex: {
        get() {
          return this.manageStore.manageTabIndex;
        },
        set(newVal) {
          this.manageStore.manageTabIndex = newVal;
        },
      },
      hasOrganization() { return this.usersAccessRightStore.hasOrganization; },
      ...mapState(useManageStore, ['openedUsers']),
    },
    created() {
      this.eventbusStore.register({
        event: 'update-user-tabs',
        listener: 'manage-users',
        cb: (userInfo) => {
          this.onUpdateProjectRightsForUser(userInfo);
        },
      });
    },
    methods: {
      onUpdateUserRights({ userId, newRight }) {
        const userIndex = this.openedUsers.findIndex(item => item.id == userId);
        if (userIndex == -1) return;
        this.openedUsers[userIndex].access_right = newRight;
        const userTab = this.$refs.userTabs[userIndex];
        if (userTab.onUpdateUserRights) userTab.onUpdateUserRights();
      },
      onUpdateProjectRightsForUser({ userId, projectId, data }) {
        const userIndex = this.openedUsers.findIndex(item => item.id == userId);
        if (userIndex == -1) return;
        const userTab = this.$refs.userTabs[userIndex];
        if (userTab.onUpdateProjectRightsForUser) userTab.onUpdateProjectRightsForUser({ userId, projectId, data });
      },
      openRemoveUserModal(user) {
        this.userToRemove = user;
      },
    },
  };
</script>
